import React from "react";
import { GetTypographyContent } from "../shared/Typography/Typography";

export const TestResultsPhysician = (
  name: string,
  label = "Physician",
): React.ReactElement => (
  <>
    {GetTypographyContent({
      content: label,
      size: "medium",
      textColor: "greyMedium",
      isBold: true,
      isCaps: true,
    })}
    {GetTypographyContent({
      content: name,
      size: "medium",
      textColor: "greyMedium",
    })}
  </>
);
